import React, { useState } from "react";
import styles from "./GeneralInformationForm.module.css";
import Header from "../../Header/Header";
import FormField from "./FormField";
import { Box, Slider, Typography } from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import config from "../../../config"; // Import config for API URL
import ProgressBar from "../../../components/ProgressBar";

const StepFour = () => {
    const [firstQuestionAnswer, setFirstQuestionAnswer] = useState(null);
    const [secondQuestionAnswer, setSecondQuestionAnswer] = useState(null);
    const [thirdQuestionAnswer, setThirdQuestionAnswer] = useState(null);
    const navigate = useNavigate();
    const location = useLocation();
    const [employmentTitle, setEmploymentTitle] = useState("");
    const [employmentInfo, setEmploymentInfo] = useState("");
    const [employmentStatus, setEmploymentStatus] = useState("");
    const [lengthOfEmployment, setLengthOfEmployment] = useState("");
    const [salary, setSalary] = useState(0);
    const [grossIncome, setGrossIncome] = useState(0);
    const [netIncome, setNetIncome] = useState(0);
    const [annualIncome, setAnnualIncome] = useState(0);
    const [totalDebit, setTotalDebit] = useState(0);
    const [monthlyDebit, setMonthlyDebit] = useState(0);
    const [activeSlider, setActiveSlider] = useState(null);

    const handleGetQualifiedClick = async (e) => {
        e.preventDefault(); // Prevent default form submission

        const data = {
            employment_title: employmentTitle,
            employment_info: employmentInfo,
            employment_status: employmentStatus,
            length_of_employment: lengthOfEmployment,
            are_you_us_citizen: firstQuestionAnswer,
            foreclosure_history: secondQuestionAnswer,
            bankruptcy_history: thirdQuestionAnswer,
            annual_income: annualIncome,
            current_debts: totalDebit,
            gross_income: grossIncome,
            monthly_expenses: monthlyDebit,
            net_income: netIncome,
            salary_or_hourly_wage: salary,
        };
        let formData = {
            ...data,
            ...location.state,
        };
        console.log("formdata-------", formData);
        // Directly retrieve token from localStorage
        navigate("/get-qualified/Step-5", { state: formData }); // Navigate to next step on success
    };

    const handleSliderChange = (setter) => (event, newValue) => {
        setter(newValue);
    };

    return (
        <main className={`${styles.mainContainer} tw-h-screen tw-border-2 tw-overflow-auto tw-bg-background_color`}>
            <Header title="Apply For Financing" />
            <section className={`${styles.formSection} tw-items-center`}>
                <ProgressBar currentStep={4} totalSteps={6} />
                <div className={`${styles.formContainer} tw-w-full max-lg:tw-w-[80%] tw-mt-10`}>
                    <h1 className={styles.formTitle}>Income and Expense</h1>
                    <p className={styles.formDescription}>
                        To help us move forward smoothly with your mortgage application, please provide the following income and employment details{" "}
                    </p>
                    <form className={styles.generalForm} onSubmit={handleGetQualifiedClick}>
                        <h1 className={styles.formTitlelittle}>Employment Details</h1>
                        <Box className={`${styles.formRow} `}>
                            {/* Annual Income Slider */}
                            <Box className={styles.formRowBox}>
                                <Typography gutterBottom>Annual Income</Typography>
                                <Slider
                                    value={annualIncome}
                                    onChange={handleSliderChange(setAnnualIncome)}
                                    min={1}
                                    max={125}
                                    marks={[
                                        { value: 1, label: "1k" },
                                        { value: 125, label: "125k+" },
                                    ]}
                                    className="tw-text-primary"
                                    valueLabelDisplay="auto"
                                    valueLabelFormat={(value) => `${value}k`}
                                    sx={{ width: "90%", marginLeft: "10px" }}
                                />
                            </Box>
                            {/* Total Debts Slider */}
                            <Box className={styles.formRowBox}>
                                <Typography gutterBottom>Total Debts</Typography>
                                <Slider
                                    value={totalDebit}
                                    onChange={handleSliderChange(setTotalDebit)}
                                    min={1}
                                    max={125}
                                    marks={[
                                        { value: 1, label: "1k" },
                                        { value: 125, label: "125k+" },
                                    ]}
                                    className="tw-text-primary"
                                    valueLabelDisplay="auto"
                                    valueLabelFormat={(value) => `${value}k`}
                                    sx={{ width: "90%", marginLeft: "10px" }}
                                />
                            </Box>
                            {/* Monthly Expenses Slider */}
                            <Box className={styles.formRowBox}>
                                <Typography gutterBottom>Monthly Debit Payments</Typography>
                                <Slider
                                    value={monthlyDebit}
                                    onChange={handleSliderChange(setMonthlyDebit)}
                                    min={1}
                                    max={125}
                                    marks={[
                                        { value: 1, label: "1k" },
                                        { value: 125, label: "125k+" },
                                    ]}
                                    className="tw-text-primary"
                                    valueLabelDisplay="auto"
                                    valueLabelFormat={(value) => `${value}k`}
                                    sx={{ width: "90%", marginLeft: "10px" }}
                                />
                            </Box>
                        </Box>
                        <div className="tw-flex tw-justify-between tw-flex-wrap">
                            <div>
                                <label className={"tw-text-[16px]"}>Are you a US citizen?</label>
                                <div className={`${styles.optionsContainer} tw-flex-nowrap ${styles.rowLayout}`}>
                                    {["Yes", "No"].map((option, index) => (
                                        <div
                                            key={index}
                                            className={`${styles.option} ${firstQuestionAnswer === option ? "tw-bg-primary hover:tw-bg-primary_hover tw-text-white" : ""}`}
                                            onClick={() => setFirstQuestionAnswer(option)}
                                        >
                                            {option}
                                        </div>
                                    ))}
                                </div>
                            </div>
                            <div>
                                <label className={"tw-text-[16px]"}>Have you had a foreclosure within the past 7 years?</label>
                                <div className={`${styles.optionsContainer} ${styles.rowLayout}`}>
                                    {["Yes", "No"].map((option, index) => (
                                        <div
                                            key={index}
                                            className={`${styles.option} ${secondQuestionAnswer === option ? "tw-bg-primary hover:tw-bg-primary_hover tw-text-white" : ""}`}
                                            onClick={() => setSecondQuestionAnswer(option)}
                                        >
                                            {option}
                                        </div>
                                    ))}
                                </div>
                            </div>
                            <div>
                                <label className={"tw-text-[16px]"}>Have you had a bankruptcy or short sale in the past 4 years?</label>
                                <div className={`${styles.optionsContainer} ${styles.rowLayout}`}>
                                    {["Yes", "No"].map((option, index) => (
                                        <div
                                            key={index}
                                            className={`${styles.option} ${thirdQuestionAnswer === option ? "tw-bg-primary hover:tw-bg-primary_hover tw-text-white" : ""}`}
                                            onClick={() => setThirdQuestionAnswer(option)}
                                        >
                                            {option}
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                        <button type="submit" className={`${styles.submitButton} tw-bg-primary hover:tw-bg-primary_hover`}>
                            Next
                        </button>
                    </form>
                </div>
            </section>
        </main>
    );
};

export default StepFour;
